import type { PlgHomeProduct } from './apis/home-api';
import { stringifyQuery, type LocationQueryRaw } from 'vue-router';

export const IP_HOME_HREF = '/ip/checking/#/home';

export function getIpHomeHref(query: LocationQueryRaw): string {
    const queryString = stringifyQuery(query);
    return queryString ? `${IP_HOME_HREF}?${queryString}` : IP_HOME_HREF;
}

export function getControlPlgHome(product: unknown): PlgHomeProduct | undefined {
    return product === 'RD' || product === 'IP' ? product : undefined;
}
